import { SortByStatusPipe } from '../../../../../../_helpers/_pipes/sort-by-status.pipe';
import { EditIconSVGComponent } from '../../../../../../modules/mapfre-design-library/src/lib/svg/edit-icon-svg/edit-icon-svg.component';
import { MapfreButtonComponent } from '../../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { MapfreModalComponent } from '../../../../../../modules/mapfre-design-library/src/lib/_components/section-components/mapfre-modal/mapfre-modal.component';
import { MapfreLoadingComponent } from '../../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/mapfre-loading/mapfre-loading.component';
import { UnenrollmentConfirmModalComponent } from '../../../my-insurance/details/unenrollment-confirm-modal/unenrollment-confirm-modal.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit , NO_ERRORS_SCHEMA } from '@angular/core';
import {
  ModalOptions,
  GTagService,
  AcmicService,
} from '@mapfre-design-library/src/public_api';
import { PaperlessService } from '../../../../../../_services/_iam/paperless.service';
import { StorageServiceObservablesService } from '@services/storage-service-observables/storage-service-observables.service';
import { Router , RouterModule } from '@angular/router';
import { PolicyDataService } from '../../../../../../_services/data-services/policy-data.service';
import { PaperlessDataService } from '../../../../../../_services/data-services/paperless-data.service';
import { UnenrollmentConfirmModalService } from '../../../../../../_services/profile-settings/unenrollment-confirm-modal.service';
import { AppRatingService } from '../../../../../../_services/pwa-service/app-rating.service';
import { Capacitor } from '@capacitor/core';
import { CustomerProfileService } from '../../../../../../_services/customer-profile/customer-profile.service';
import { AgentNotificationService } from './../../../../../../_services/agent/agent-notification.service';
import { CompanyService } from '@services/my-insurance/company.service';
import { NavigationService } from '@services/navigation.service';
import { ClientCredentialsService } from '@services/client-credentials/client-credentials.service';

@Component({
  standalone: true,
  schemas: [NO_ERRORS_SCHEMA],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, UnenrollmentConfirmModalComponent, MapfreLoadingComponent, MapfreModalComponent, MapfreButtonComponent, EditIconSVGComponent, SortByStatusPipe],
  selector: 'app-paperless-time',
  templateUrl: './paperless-time.component.html',
})
export class PaperlessFirstTimeComponent implements OnInit {
  checkForEligibility: boolean;
  emailaddress: string;
  endEnrollOptionsModal: ModalOptions;
  enrollOptionsModal: ModalOptions;
  firstTime = false;
  hideModal: boolean;
  loading = true;
  policyInfo: any;
  user: any;
  enrollPolicyId: string;
  allPoliciesEligible: any;
  payOrBill: any;
  ebillEnrolled = false;
  loader = false;
  allAs400Policies: any = [];
  allLivoPolicies: any = [];
  isWAStatepolicy: any = [];
  confirmModal: boolean;
  where: string;
  onRemovePolicy: any;
  custom_loader: any;
  isAcmic: boolean;
  showCompany: string;
  showAlert: boolean;
  
  constructor(
    private unenrollmentConfirmModalService: UnenrollmentConfirmModalService,
    private paperlessService: PaperlessService,
    private policyDataService: PolicyDataService,
    private storageServiceObservablesService: StorageServiceObservablesService,
    public router: Router,
    private paperlessDataService: PaperlessDataService,
    private gTagService: GTagService,
    private acmicService: AcmicService,
    private appRatingService: AppRatingService,
    private customerProfileService: CustomerProfileService,
    private agentNotification: AgentNotificationService,
    private companyService: CompanyService,
    private navService: NavigationService,
    private clientCredentialsService: ClientCredentialsService
  ) {
    this.enrollOptionsModal = this.paperlessDataService.getEnrollModel(
      'modal-medium enroll modal-dialog',
      'btn mapfre basic no-margin float-right primary ghost x-small-btn enroll-btn w100 h40',
      'ENROLL',
      'enrollModal',
      'MODAL_ENROLL_TITLE'
    );
  }

  onRemoveAccount(policy, where) {
    if (
      (policy &&
        policy['days_left_to_expire'] &&
        policy['days_left_to_expire'] <= 30 &&
        policy.policynumber.policyNumber.length === 6 &&
        policy.livoPolicy) ||
      (policy &&
        policy['days_left_to_expire'] &&
        policy['days_left_to_expire'] == -1) ||
      policy['isNewPolicy']
    ) {
      this.paperlessDataService.showToast();
    } else {
      this.confirmModal = true;
      this.where = where;
      this.onRemovePolicy = policy;
    }
    window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
  }

  enroll(policy, where): void {
    this.agentNotification.setAgentInfo(policy);
    this.agentNotification.setHeader(policy);
      const email = this.storageServiceObservablesService.getUserFromStorage();
      this.loader = true;
      if (where == 'e-policy') {
        this.paperlessService
          .enrollPaperlessEPolicyV2(policy.policynumber.policyNumber, email)
          .subscribe(
            () => {
              this.enrollSuccess(policy, where);
              this.gTagService.triggerFormLink(
                'enrollPaperlessEPolicy',
                'true',
                ''
              );
              if (Capacitor.isNativePlatform()) {
                this.appRatingService.rateApp();
              }
            },
            (errorRes) => {
              this.enrollError(errorRes, policy.policynumber.policyNumber);
              this.gTagService.triggerFormLink(
                'enrollPaperlessEPolicy',
                'false',
                'enroll paperless epolicy error'
              );
            }
          );
      } else if (where == 'e-bill') {
        this.paperlessService
          .enrollPaperlessEBill(policy.policynumber.policyNumber, email)
          .subscribe(
            () => {
              this.enrollSuccess(policy, where, email);
            },
            (errorRes) => {
              this.enrollError(errorRes, policy.policynumber.policyNumber);
            }
          );
      }
    // }
  }

  enrollError(errorRes, policyId) {
    this.loader = false;
    this.hideModal = true;
    window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
    this.paperlessDataService.errorHandler(errorRes, policyId);
  }
  enrollSuccess(policy, where, email?) {
    this.loader = false;
    this.paperlessDataService.enrollSuccessMessage(policy, where);
    if (where == 'e-policy') {
      this.updatePolicyInfo(policy, 'ENROLL', where);
    } else if (where == 'e-bill') {
      this.loading = true;
      this.paperlessDataService.reSync(email);
    }
    window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
    if (policy.policynumber.policyNumber.length === 10) {
      this.customerProfileService.setModalTitle('PAPERLESS');
    }
  }

  updatePolicyInfo(policy, Type, where) {
    if (policy && policy.policynumber.policyNumber.length === 6) {
      for (let i = 0; i < this.allAs400Policies.length; i++) {
        if (
          this.allAs400Policies[i].policynumber.policyNumber ===
          policy.policynumber.policyNumber
        ) {
          if (where == 'e-policy') {
            this.allAs400Policies[i].policyFlags.isEdf =
              Type === 'ENROLL' ? 'ENROLLMENT-PENDING' : 'UNENROLLMENT-PENDING';
          } else if (where == 'e-bill') {
            this.allAs400Policies[i].policyFlags.isEbill =
              Type === 'ENROLL' ? 'TRUE' : 'FALSE';
          }
        }
      }
    } else if (policy && policy.policynumber.policyNumber.length > 6) {
      for (let i = 0; i < this.allLivoPolicies.length; i++) {
        if (
          this.allLivoPolicies[i].policynumber.policyNumber ===
          policy.policynumber.policyNumber
        ) {
          if (where == 'e-policy') {
            this.allLivoPolicies[i].policyFlags.isEdf =
              Type === 'ENROLL' ? 'TRUE' : 'FALSE';
          } else if (where == 'e-bill') {
            this.allLivoPolicies[i].policyFlags.isEbill =
              Type === 'ENROLL' ? 'TRUE' : 'FALSE';
          }
        }
      }
    }
  }

  hideModalAction(): void {
    this.hideModal = !this.hideModal;
  }

  resetHideModal(): void {
    this.hideModal = !this.hideModal;
  }

  redirect_edit_email() {
    this.paperlessService.setCurrentRoute('/billing/paperless');
    this.router.navigate(['profile', 'manage-contact-details']);
  }

  closeUnenrollModal() {
    this.confirmModal = false;
  }
  goToMyAccount() {
    this.navService.navigateBack()
  }
  ngOnInit() {
    this.isAcmic = this.acmicService.isACMIC();
    this.loading = true;
    this.paperlessService.setCurrentRoute('');
    this.user = this.storageServiceObservablesService.getUserFromStorage();

    this.companyService.$currentCompany.subscribe((company)=>{
      this.showCompany = company;
    })

    this.policyDataService.$policyDetails.subscribe((policyResponse) => {
      if (policyResponse) {
        this.policyInfo = policyResponse;
        this.allAs400Policies =
          this.paperlessDataService.as400policy(policyResponse);
        this.allLivoPolicies =
          this.paperlessDataService.livoPolicy(policyResponse);
        this.isWAStatepolicy =
          this.paperlessDataService.waStatepolicy(policyResponse);
        this.checkForEligibility =
          this.paperlessDataService.checkAllPoliciesForEligibilty();
        this.loading = false;
      }
    });

    this.unenrollmentConfirmModalService.$removeAccount.subscribe(
      (removeAccount) => {
        this.confirmModal = removeAccount;
      }
    );

    this.policyDataService.$removePaperless.subscribe((status) => {
      if (status) {
        this.updatePolicyInfo(this.onRemovePolicy, 'CANCEL', status.where);
      }
    });

    this.clientCredentialsService.getToken().subscribe(() => {
      if (this.router.url === '/billing/paperless' || this.router.url === '/billing/autopay') {
            this.showAlert = true;
      }
    })
  }
}
